import { NgModule } from '@angular/core';
import { FiProgressBadgeComponent } from './fi-progress-badge.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '../app-text';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [FiProgressBadgeComponent],
    exports: [FiProgressBadgeComponent],
})
export class FiProgressBadgeModule {}
